import { css } from "@emotion/react";

const input = prop => css`
  flex-grow: 1;

  .MuiInputBase-input {
    color: ${prop.theme.colors.black};
    @media (max-width: ${prop.theme.screenSizes.mdMax}) {
      height: 56px !important;
      font-size: 16px;
    }
  }
`;

const heading = css`
  max-width: 980px;
`;

const button = prop => css`
  padding: 24px 32px;
  @media (max-width: ${prop.theme.screenSizes.mdMax}) {
    width: 100%;
    padding: 14px 32px;
  }
`;

export const addStyles = { input, heading, button };
